import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultWidth = 14;
const defaultHeight = 16;
const defaultRatio = defaultWidth / defaultHeight;

export enum Direction {
  Down,
  Left,
  Up,
  Right,
}

type PropsType = SVGComponentPropsType & {
  direction?: Direction;
  color?: string;
  size?: number;
};

const arrow = ({ direction = Direction.Up, color = defaultIconColor, size = defaultHeight, ...props }: PropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultWidth} ${defaultHeight}`}
    height={`${size}`}
    width={`${size * defaultRatio}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" transform={`rotate(${direction * 90}, 7, 8)`}>
      <path d="M7 0v14M1 8l6 6 6-6" />
    </g>
  </svg>
);

arrow.Direction = Direction;

export default arrow;
